import { render, staticRenderFns } from "./PromoBannerHeroes.vue?vue&type=template&id=a32d9e0a&"
import script from "./PromoBannerHeroes.vue?vue&type=script&lang=js&"
export * from "./PromoBannerHeroes.vue?vue&type=script&lang=js&"
import style0 from "./PromoBannerHeroes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PromoBannerHeroes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports